import { FunctionComponent, PropsWithChildren } from 'react';
import { SettingsProvider } from '../settings';
import { AuthProvider, useAuth } from '../auth';
import { Apollo } from '@shared/utils/apollo';
import { AppContext, TAppContext } from './app.context';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';

const WaitForLogin: FunctionComponent<PropsWithChildren> = ({ children }) => {
  const auth = useAuth();
  if (auth.isLoading) {
    return <></>;
  }
  return <>{children}</>;
};

export const AppProviders: FunctionComponent<
  PropsWithChildren<{
    disableProfileRedirect?: boolean;
  } & TAppContext>
> = ({ children, disableProfileRedirect, ...appContext }) => {
  return (
    <>
      <AppContext.Provider value={appContext}>
        <LocalizationProvider dateAdapter={AdapterDateFns}>
          <SettingsProvider>
            <AuthProvider disableProfileRedirect={disableProfileRedirect}>
              <WaitForLogin>
                <Apollo>{children}</Apollo>
              </WaitForLogin>
            </AuthProvider>
          </SettingsProvider>
        </LocalizationProvider>
      </AppContext.Provider>
    </>
  );
};
